import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/cartContext';
// import '@fortawesome/fontawesome-free/css/all.min.css';

function CustomDrawer({ isOpen, onClose, hasToken, roles, handleLogout, cartItems, setShowDropdown, showDropdown }) {
  const navigate = useNavigate()
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="drawer-backdrop"
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1040,
        }}
      />

      {/* Drawer */}
      <div
        className="custom-drawer"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '300px',
          height: '100vh',
          backgroundColor: '#fff',
          zIndex: 1050,
          boxShadow: '-2px 0 5px rgba(0,0,0,0.2)',
          // padding: '1rem',
          transition: 'transform 0.3s ease-in-out',
        }}
      >
        <div style={{padding: "5px 20px"}}
        className="d-flex justify-content-between align-items-center mb-3 custom-border-bottom">
          {/* <h5>Menu</h5>  */}
          <div>
            <img width={60} src="static/img/logo.png" alt="" srcset="" />
          </div>
          <div>
          <button onClick={onClose} className="btn-close" />
          </div>
        </div>

        <ul className="list-unstyled">
          <li className="pt-2 pb-2 custom-border-bottom custom-hover">
            <Link style={{ color:"#666666", padding: "5px 20px",fontWeight:"400", fontSize: "medium" }} 
            to="/contact" onClick={onClose}>
              
              Message Us
            </Link>
          </li>
          <li className="pt-2 pb-2 custom-border-bottom custom-hover">
            <Link style={{ color:"#666666", padding: "5px 20px",fontWeight: "400", fontSize: "medium" }}
            to="/career" onClick={onClose}>
              Career
            </Link>
          </li>
          <li className="pt-2 pb-2 custom-border-bottom custom-hover">
            <Link to="/cart" style={{ color:"#666666", padding: "5px 20px",fontWeight: "400", fontSize: "medium" }}
            
            onClick={onClose} 
            // className="d-flex align-items-center gap-2">
            >
              Cart
              {cartItems.length > 0 && (
                <span className="badge bg-danger rounded-circle">
                  {cartItems.length}
                </span>
              )}
            </Link>
          </li>
          {!hasToken || roles !== 'User' ? (
            <li className="mb-2 p-3">
              <button className='btn btn-md circle w-100 animation mt-20'
    onClick={() => {
      onClose();
      navigate('/user-login');
    }}
    
  >
    Login
  </button>
            </li>
          ) : (
            <li className="mb-2" style={{ position: 'relative' }}>
              <img
                src="/avtar.jpg"
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: '50%', cursor: 'pointer' }}
                onClick={() => setShowDropdown((prev) => !prev)}
              />
              {showDropdown && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50px',
                    right: 0,
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    borderRadius: '5px',
                    zIndex: 10,
                  }}
                >
                  <button className='btn btn-md circle w-100 animation mt-20'
                    onClick={() => {
                      handleLogout();
                      onClose();
                    }}
                  >
                    Logout
                  </button>
                </div>
              )}
            </li>
          )}
        </ul>
      </div>
    </>
  );
}

function NavigationBar() {
  const refElement = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);
  const [userData, setUserData] = useState(null);
  const [roles, setRoles] = useState(null);
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    const userType = localStorage.getItem('userType');
    setUserData(user ? JSON.parse(user) : null);
    setRoles(userType);
    setHasToken(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setHasToken(false);
    setShowDropdown(false);
    navigate('/user-login');
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) {
        setMenuOpen(false);
        setShowMobileDropdown(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const showDropdownMenu = () => {
    if (refElement.current && !isMobile) {
      refElement.current.style.display = 'block';
    }
  };

  const hideDropdownMenu = () => {
    if (refElement.current && !isMobile) {
      refElement.current.style.display = 'none';
    }
  };

  const handleToggleClick = () => {
    setMenuOpen((prev) => {
      const isOpen = !prev;
      document.querySelector('.navbar')?.classList.toggle('navbar-responsive', isOpen);
      document.querySelector('.overlay-screen')?.classList.toggle('opened', isOpen);
      document.querySelector('.navbar-collapse')?.classList.toggle('show', isOpen);
      document.querySelector('.navbar-collapse')?.classList.toggle('collapse-mobile', isOpen);
      document.querySelector('header')?.classList.toggle('adjust-height', isOpen);
      return isOpen;
    });
  };

  return (
    <header>
      <nav className="navbar mobile-sidenav navbar-default validnavs navbar-fixed white no-background">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle" onClick={handleToggleClick}>
              <i className={`fa ${menuOpen ? 'fa-times' : 'fa-bars'}`} style={{ fontWeight: 900 }} />
            </button>
            <Link className="navbar-brand" to="/">
              <img title="Microcode Software" src="static/img/logo-light.png" className="logo logo-display" alt="Logo" />
              <img title="Microcode Software" src="static/img/logo.png" className="logo logo-scrolled" alt="Logo" />
            </Link>
          </div>

          <div className="collapse navbar-collapse" id="navbar-menu">
            <div className="collapse-header">
              <img title="Microcode Software" src="static/img/logo.png" alt="Logo" />
              <button type="button" className="navbar-toggle" onClick={handleToggleClick}>
                <i className="fa fa-times" style={{ fontWeight: 900 }} />
              </button>
            </div>
            <ul className="nav navbar-nav navbar-center">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li className="dropdown" onMouseEnter={showDropdownMenu} onMouseLeave={hideDropdownMenu}>
                <Link to="#" onClick={(e) => isMobile && (e.preventDefault(), setShowMobileDropdown(!showMobileDropdown))}>
                  Our Services
                </Link>
                <ul
                  ref={refElement}
                  className="dropdown-menu"
                  style={{ display: isMobile ? (showMobileDropdown ? 'block' : 'none') : undefined }}
                >
                  <li><Link to="/application-development">Application Development</Link></li>
                  <li><Link to="/social-media-marketing">Social Media Marketing</Link></li>
                  <li><Link to="/performance-marketing">Performance Marketing</Link></li>
                  <li><Link to="/software-development">Software Development</Link></li>
                  <li><Link to="/website-development">Website Development</Link></li>
                  <li><Link to="/shopify-development">Shopify Development</Link></li>
                  <li><Link to="/seo-services">SEO Services</Link></li>
                </ul>
              </li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              {isMobile && (
                <>
                  <li><Link to="/contact"> Message Us</Link></li>
                  <li><Link to="/career"> Career</Link></li>
                  <li><Link to="/cart"> Cart</Link></li>
                  <li>
                    {!hasToken || roles !== 'User' ? (
                      <Link to="/user-login" onClick={() => localStorage.clear()}>Login</Link>
                    ) : (
                      <Link onClick={handleLogout}>Logout</Link>
                    )}
                  </li>
                </>
              )}
            </ul>
          </div>

          {/* Right Drawer Toggle Button */}
          <div className="attr-right">
            <div
              role="button"
              onClick={() => setDrawerOpen(true)}
              style={{ cursor: 'pointer', fontSize: '28px', display: 'flex', alignItems: 'center' }}
            >
              <i className="fa-solid fa-bars" style={{ color: 'white' }} />
            </div>
          </div>

          {/* Mobile Contact Icon */}
          <div className="attr-right d-block d-sm-block d-lg-none">
            <div className="attr-nav">
              <ul>
                <li className="contact d-block d-sm-block d-lg-none">
                  <div className="call">
                    <a href="mailto:contact@microcode.email">
                      <div className="icon">
                        <i className="fas fa-comments-alt-dollar" />
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="overlay-screen" onClick={handleToggleClick} />
      </nav>

      {/* Custom Drawer Component */}
      <CustomDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        hasToken={hasToken}
        roles={roles}
        handleLogout={handleLogout}
        cartItems={cartItems}
        setShowDropdown={setShowDropdown}
        showDropdown={showDropdown}
      />
    </header>
  );
}

export default NavigationBar;
